const apiUrl = import.meta.env.VITE_API_SERVER_URL;

export const generateEventId = (): string => crypto.randomUUID();

/**
 * Fire a Meta Pixel event with an eventID for CAPI deduplication.
 */
export const fireMetaPixelEvent = (
  eventName: string,
  customData: Record<string, unknown> = {},
  eventId: string,
): void => {
  try {
    if (typeof window !== 'undefined' && window.fbq) {
      window.fbq('track', eventName, customData, { eventID: eventId });
    }
  } catch {
    // Silent fail — tracking should never break the app
  }
};

/**
 * Fire a Meta Pixel custom event (trackCustom).
 */
export const fireMetaPixelCustomEvent = (
  eventName: string,
  customData: Record<string, unknown> = {},
): void => {
  try {
    if (typeof window !== 'undefined' && window.fbq) {
      window.fbq('trackCustom', eventName, customData);
    }
  } catch {
    // Silent fail
  }
};

/**
 * Send session start data to the backend tracking endpoint.
 */
export const sendSessionStart = async (data: Record<string, unknown>): Promise<void> => {
  try {
    await fetch(`${apiUrl}/api/tracking/session`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(data),
    });
  } catch {
    // Silent fail — tracking should never break the app
  }
};
